import Rating from '../model/rating'

export default function ratingToNumber(rating: Rating | null) {
  switch (rating) {
    case 'VeryPoor':
      return 1
    case 'Poor':
      return 2
    case 'Average':
      return 3
    case 'Good':
      return 4
    case 'Excellent':
      return 5
    default:
      return 0
  }
}
